const HomeIcon = (props: any) => {
    return (
        <img {...props} alt="home_icon.png" src={require('./home_icon.png')} />
    );
};

export default HomeIcon;
